import React, { useState, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { AgGrid } from '../AgGrid';
import { getOrdersColumnDefinitions } from '../../helpers/columnDefinitions';
import { BulkAssignDialog } from '../BulkAssignDialog';
import { BulkReleaseDialog } from '../BulkReleaseDialog';
import { ImportAssignmentDialog } from '../ImportAssignmentDialog';
import { Button } from '@material-ui/core';
import { AppContext } from '../../AppContext';
import ROLES, { hasPermission } from '../../helpers/roles';
// import PropTypes from "prop-types";

// SERVICES
import { getInspectorsOptions, bulkAssignOrdersToInspector, bulkReassignOrders,  bulkReleaseCallAheadOrders } from '../../services';
import { orderLineStatusLookupCodes } from '../../enums';

const styles = theme => ({})

export const OrdersGrid = withRouter(
  withStyles(styles)(props => {
    const { classes } = props;
    const {
      state: { roles },
    } = useContext(AppContext);
    const [orderData, setOrderData] = useState(null);
    const [showBulkEditDialog, setShowBulkEditDialog] = useState(false);
    const [showBulkReleaseDialog, setShowBulkReleaseDialog] = useState(false);
    const [showImportAssignmentDialog, setShowImportAssignmentDialog] = useState(false);
    const [bulkEditRowData, setBulkEditRowData] = useState([]);
    const [bulkReleaseRowData, setBulkReleaseRowData] = useState([]);
    const [dialogValues, setDialogValues] = useState({
      inspectorId: null,
    });
    const [inspectorOptions, setInspectorOptions] = useState(null);
    const [gridKey, setGridKey] = useState(new Date().getTime());

    const columnDefinitions = getOrdersColumnDefinitions('admin', 'admin', true);
    const gridOptions = {
      // detailCellRendererParams,
      // masterDetail: true,
      rowSelection: 'multiple',
    };
    const defaultStatusCodeValues = Object.keys(orderLineStatusLookupCodes).filter(
      code => code !== 'CL-DELIVERED' && code !== 'PO-ASSIGNED' && code !== 'IQ-PENDING',
    );

    const getInspectorsOptionsAsync = async () => {
      try {
        let inspectorList = await getInspectorsOptions();
        setInspectorOptions(inspectorList);
      } catch (error) {
        console.log(error);
      }
    };

    const openBulkEditDialog = rowData => {
      setBulkEditRowData(rowData.map(row => row.orderTicket).sort((a, b) => (a > b ? 1 : -1)));
      setShowBulkEditDialog(true);
    };

    const openBulkReleaseDialog = rowData => {
      setBulkReleaseRowData(rowData.map(row => row.orderTicket).sort((a, b) => (a > b ? 1 : -1)));
      setShowBulkReleaseDialog(true);
    };

    const handleBulkAssignment = (orderTickets, inspectorId) => {
      return !!inspectorId ? bulkAssignOrdersToInspector(orderTickets, inspectorId) : bulkReassignOrders(orderTickets);
    };

    const handleBulkRelease = (orderTickets) => {
      return bulkReleaseCallAheadOrders(orderTickets);
    };

    const handleBulkAssignDialogClose = shouldRefetch => {
      setShowBulkEditDialog(false);

      if (shouldRefetch) {
        setGridKey(new Date().getTime());
      }
    };

    const handleBulkReleaseDialogClose = shouldRefetch => {
      setShowBulkReleaseDialog(false);

      if (shouldRefetch) {
        setGridKey(new Date().getTime());
      }
    };

    const handleImportAssignmentDialogClose = shouldRefetch => {
      setShowImportAssignmentDialog(false);

      if (shouldRefetch) {
        setGridKey(new Date().getTime());
      }
    };

    const importAssignmentButton = hasPermission([ROLES.ADMIN], roles) ? (
      <Button
        style={{ backgroundColor: '#315382', color: '#fff', marginRight: 15 }}
        variant="contained"
        onClick={() => setShowImportAssignmentDialog(true)}
      >
        Import Assignment
      </Button>
    ) : null;

    useEffect(() => {
      getInspectorsOptionsAsync();
    }, []);

    return (
      <div className={classnames('flex-1', 'card', 'border-left-green')} style={{flex: 1, alignSelf: 'stretch'}}>
        <AgGrid
          // force rerender when dialog closes
          key={`orders_grid_${gridKey}`}
          gridData={[]}
          columnDefs={columnDefinitions}
          handleCreateClick={evt => (window.location = `${window.location.href}/create`)}
          handleCellClick={evt => props.history.push(`/orders/${evt.data.orderTicket}`)}
          redirectOnClick={true}
          editOnClick={false}
          rowClassRules={{
            'row-pastDue': 'data.pastDue === true',
          }}
          gridOptions={gridOptions}
          headerContent={importAssignmentButton}
          openBulkEditDialog={hasPermission([ROLES.ADMIN], roles) ? openBulkEditDialog : null}
          openBulkReleaseDialog={openBulkReleaseDialog}
          datasourceUrl={'/orders'}
          useDatasource={true}
          gridName={'MAIN_GRID'}
          defaultFilters={[
            {
              name: 'orderLineStatusLookupCode',
              model: {
                filterType: 'set',
                values: defaultStatusCodeValues,
              },
            },
          ]}
          className={'ag-theme-material'}
        />

        <BulkAssignDialog
          {...props}
          onConfirm={handleBulkAssignment}
          rowData={bulkEditRowData || []}
          personOptions={inspectorOptions}
          personValueField={'inspectorId'}
          personPlaceholder={'Search for an inspector'}
          show={showBulkEditDialog}
          dialogValues={dialogValues}
          setDialogValues={setDialogValues}
          setOrderData={setOrderData}
          onClose={handleBulkAssignDialogClose}
          allowAutoReassignment
        />
        
        <BulkReleaseDialog
          {...props}
          onConfirm={handleBulkRelease}
          rowData={bulkReleaseRowData || []}
          show={showBulkReleaseDialog}
          dialogValues={dialogValues}
          // setDialogValues={setDialogValues}
          // setOrderData={setOrderData}
          onClose={handleBulkReleaseDialogClose}
          // allowAutoReassignment
        />

        <ImportAssignmentDialog show={showImportAssignmentDialog} onClose={handleImportAssignmentDialogClose} />
      </div>
    );
  }),
);

OrdersGrid.propTypes = {};

OrdersGrid.defaultProps = {};
